// src/admin/AdminLayout.jsx — full replacement
import React, { useState, useEffect } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';

const TABS = [
  { label: 'Panoramica', path: '/admin/overview' },
  { label: 'Utenti', path: '/admin/users' },
  { label: 'Tenant', path: '/admin/tenants' },
  { label: 'Piani', path: '/admin/plans' },
];

function tabStyle(isActive) {
  return {
    padding: '8px 16px',
    fontSize: '13px',
    fontWeight: isActive ? 600 : 400,
    color: isActive ? '#E8002D' : '#6c6c6d',
    textDecoration: 'none',
    borderBottom: isActive ? '2px solid #E8002D' : '2px solid transparent',
    fontFamily: "'DM Sans', sans-serif",
    transition: 'all 0.15s',
  };
}

export default function AdminLayout() {
  const [showBlockedBanner, setShowBlockedBanner] = useState(false);
  const location = useLocation();
  const hideTabs = location.pathname.startsWith('/admin/runs');

  useEffect(() => {
    try {
      if (sessionStorage.getItem('sa_blocked_banner') === '1') {
        setShowBlockedBanner(true);
        sessionStorage.removeItem('sa_blocked_banner');
      }
    } catch { /* private mode */ }
  }, []);

  return (
    <div>
      {showBlockedBanner && (
        <div style={{
          padding: '10px 40px',
          background: 'rgba(232,0,45,0.08)',
          borderBottom: '1px solid rgba(232,0,45,0.2)',
          color: '#B91C1C',
          fontFamily: "'DM Sans', sans-serif",
          fontSize: '13px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '12px',
        }}>
          <span>I superadmin non utilizzano le applicazioni — usa la console admin.</span>
          <button
            onClick={() => setShowBlockedBanner(false)}
            style={{
              background: 'transparent', border: 'none', cursor: 'pointer',
              color: '#B91C1C', fontSize: '15px', fontWeight: 600,
            }}
            aria-label="Chiudi"
          >
            ✕
          </button>
        </div>
      )}
      {!hideTabs && (
        <div style={{
          display: 'flex', gap: '4px', padding: '0 40px',
          borderBottom: '1px solid rgba(0,0,0,0.06)',
          background: '#ffffff',
        }}>
          {TABS.map(tab => (
            <NavLink
              key={tab.path}
              to={tab.path}
              style={({ isActive }) => tabStyle(isActive)}
            >
              {tab.label}
            </NavLink>
          ))}
        </div>
      )}
      <Outlet />
    </div>
  );
}
